import SearchLinePrimary1616 from '@svg/travel-card/search_line_primary_16_16.svg';
import CancelFillGray1818 from '@svg/travel-card/cancel_fill_gray_18_18.svg';

export default function SearchInputBarBasic({
  searchQuery,
  setSearchQuery,
}: {
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <div className='relative'>
      <input
        type='text'
        placeholder='검색어를 입력해 주세요'
        className='peer w-full py-12pxr pr-16pxr focus:pr-36pxr pl-42pxr text-new-gray-900 placeholder:text-new-gray-500 body-14-regular bg-new-gray-100 rounded-8pxr focus:ring-1 focus:ring-new-point-500 focus:outline-none'
        onChange={(e) => {
          setSearchQuery(e.target.value);
        }}
        value={searchQuery}
      />
      <div className='w-20pxr h-20pxr absolute flex items-center justify-center top-12pxr left-14pxr'>
        <SearchLinePrimary1616 />
      </div>
      {searchQuery && (
        <button
          className='peer-focus:flex hidden w-20pxr h-20pxr absolute items-center justify-center top-12pxr right-12pxr'
          onClick={() => {
            setSearchQuery('');
          }}
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          <CancelFillGray1818 />
        </button>
      )}
    </div>
  );
}
